import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';

export default function FormCheckbox({
  name,
  disabled,
  sublabel,
  label,
  color,
  checkStyles,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Controller
            name={name}
            control={control}
            render={({
              field: { value, onChange, ...field },
              fieldState: { error },
            }) => {
              return (
                <Checkbox
                  {...field}
                  checked={value === 'true' || value === true}
                  onChange={(e) =>
                    onChange(e.target.checked ? 'true' : 'false')
                  }
                  disabled={disabled}
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fill: error
                        ? (theme) => theme.palette.error.main
                        : (theme) => theme.palette[color || 'primary'].main,
                    },
                    ...checkStyles,
                  }}
                />
              );
            }}
          />
        }
        label={
          <span
            style={{ fontSize: '14px', lineHeight: '100%' }}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        }
        {...other}
      />
    </FormGroup>
  );
}

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  sublabel: PropTypes.string,
};

FormCheckbox.defaultProps = {
  disabled: false,
};
